(function () {
  var loading = false;
  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) load(en.target); });
      }, { rootMargin: '900px 0px' })
    : null;

  function fmt(n) { return Number(n).toLocaleString('en-ZA'); }

  function paint(more, busy) {
    var total = Number(more.dataset.total), loaded = Number(more.dataset.loaded);
    var status = more.querySelector('[data-status]');
    var bar = more.querySelector('[data-bar]');
    var btn = more.querySelector('[data-more]');
    var done = !more.dataset.next;
    if (status) {
      status.textContent = busy ? 'Loading more… ' + fmt(loaded) + ' of ' + fmt(total)
        : done ? 'All ' + fmt(total) + ' loaded' : 'Loaded ' + fmt(loaded) + ' of ' + fmt(total);
    }
    if (bar) bar.style.width = (total ? Math.min(100, loaded * 100 / total) : 100) + '%';
    more.classList.toggle('is-loading', !!busy);
    if (btn) btn.hidden = done || !!busy;
  }

  function load(more) {
    if (loading || !more.isConnected || !more.dataset.next) return Promise.resolve();
    loading = true;
    paint(more, true);
    return fetch(more.dataset.next, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = document.querySelector(more.dataset.grid);
        var next = doc.querySelector('[data-fbtr-more]');
        var src = doc.querySelector(more.dataset.grid);
        if (!grid || !src) throw new Error('no grid');
        var added = src.children.length;
        grid.append.apply(grid, Array.prototype.slice.call(src.children));
        more.dataset.loaded = Number(more.dataset.loaded) + added;
        more.dataset.next = next ? next.dataset.next : '';
        document.dispatchEvent(new CustomEvent('fbtr:items-added'));
      })
      .catch(function () { more.dataset.next = ''; })
      .then(function () {
        loading = false;
        paint(more, false);
        if (more.dataset.next && io) { io.unobserve(more); io.observe(more); }
      });
  }

  // Coming back (browser Back) to a long list: reload the pages that were open and return to the same spot
  var KEY = 'fbtr-inf:' + location.pathname + location.search;
  function save() {
    var more = document.querySelector('[data-fbtr-more]');
    if (!more || !more._fbtr) return;
    try { sessionStorage.setItem(KEY, JSON.stringify({ loaded: Number(more.dataset.loaded), y: window.scrollY })); } catch (e) { /* no storage */ }
  }
  function restore(more) {
    var saved = null;
    try { saved = JSON.parse(sessionStorage.getItem(KEY)); } catch (e) { /* none */ }
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (!saved || !nav || nav.type !== 'back_forward') return;
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    (function step() {
      if (Number(more.dataset.loaded) >= saved.loaded || !more.dataset.next) { window.scrollTo(0, saved.y); return; }
      if (loading) { setTimeout(step, 100); return; }
      load(more).then(step);
    })();
  }
  window.addEventListener('pagehide', save);
  document.addEventListener('click', function (e) {
    if (e.target instanceof Element && e.target.closest('a[href]')) save();
  }, true);

  function init() {
    var more = document.querySelector('[data-fbtr-more]');
    if (!more || more._fbtr) return;
    more._fbtr = true;
    document.documentElement.classList.add('fbtr-inf');
    paint(more, false);
    restore(more);
    var btn = more.querySelector('[data-more]');
    if (btn) btn.addEventListener('click', function () { load(more); });
    if (io) io.observe(more);
  }

  // Backup for browsers that pause IntersectionObserver (background tabs): check on scroll too
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    setTimeout(function () {
      ticking = false;
      var more = document.querySelector('[data-fbtr-more]');
      if (more && more._fbtr && more.getBoundingClientRect().top < window.innerHeight + 900) load(more);
    }, 150);
  }, { passive: true });

  // Filters re-render the grid: pick up the new status block each time
  var timer;
  new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(init, 60); })
    .observe(document.body, { childList: true, subtree: true });
  init();
})();
